module.exports = __webpack_public_path__ + "static/img/3.9c70c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shangji/3.png
// module id = Wcos
// module chunks = 1